module.exports = __webpack_public_path__ + "img/OvalCopy2@2x.bc69b90c.png";